export default "__VITE_ASSET__507511ca__"